import { Component, Input } from '@angular/core';
import { AbstractControl } from '@angular/forms';

import { ValidationService } from './validation.service';

// TODO: rework it to allow overriding default messages
@Component({
  selector: 'control-messages',
  templateUrl: './control-messages.component.html',
  styleUrls: ['./control-messages.component.scss'],
  standalone: false,
})
export class ControlMessagesComponent {
  @Input() control?: AbstractControl;
  @Input() showUntoched = false;

  get errorMessages() {
    if (!this.control) {
      return null;
    }

    const errors = Object.entries({ ...this.control.errors });
    if (!errors.length) return null;

    const errorMessageList = errors.map(([errorKey, value]) => {
      if (errorKey === 'ngbDate') {
        return ValidationService.getValidatorErrorMessage('required');
      }

      if (value && (this.control.touched || this.showUntoched)) {
        return ValidationService.getValidatorErrorMessage(errorKey, value);
      }

      return '';
    });

    return errorMessageList.length ? errorMessageList : null;
  }
}
